import CollectCage from './CollectCage';

export default CollectCage;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/CollectCage/index.jsx